import * as Types from '../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteMeetingMutationVariables = Types.Exact<{
  meetingId: Types.Scalars['Int']['input'];
}>;


export type DeleteMeetingMutation = { __typename?: 'Mutation', deleteMeeting: Array<{ __typename?: 'FieldError', path: Array<string>, message?: string | null, data:
      | { __typename?: 'GenericError', key: Types.ValueErrorType }
      | { __typename?: 'LimitedValueError', key: Types.ValueErrorType, limitValue: number }
      | { __typename?: 'PositiveRangeDatetimeError', key: Types.ValueErrorType, startField: string, endField: string }
     }> };

export type MeetingsQueryVariables = Types.Exact<{
  meetingId: Types.Scalars['Int']['input'];
}>;


export type MeetingsQuery = { __typename?: 'Query', meetings?: { __typename?: 'MeetingList', items: Array<{ __typename?: 'Meeting', id: number, startTime: any, length?: number | null, summary: string, pinCode?: string | null, description?: string | null, roomId: string, allowUnmute: boolean } | null> } | null };

export type MeetingViewQueryVariables = Types.Exact<{
  meetingId: Types.Scalars['Int']['input'];
}>;


export type MeetingViewQuery = { __typename?: 'Query', meetings?: { __typename?: 'MeetingList', items: Array<{ __typename?: 'Meeting', id: number, startTime: any, length?: number | null, summary: string, pinCode?: string | null, description?: string | null, roomId: string, allowUnmute: boolean } | null> } | null, invitations?: { __typename?: 'InvitationList', items: Array<{ __typename?: 'Invitation', id: number, pinCodeRequired: boolean, callout: boolean, muted: boolean, email?: string | null, phoneNumber?: string | null, name?: string | null, uuid: string, type: Types.InvitationType, isAutoGenerated: boolean, meetingId: number, joinUrl?: string | null } | null> } | null };


export const DeleteMeetingDocument = gql`
    mutation DeleteMeeting($meetingId: Int!) {
  deleteMeeting(meetingId: $meetingId) {
    path
    message
    data {
      ... on GenericError {
        key
      }
      ... on LimitedValueError {
        key
        limitValue
      }
      ... on PositiveRangeDatetimeError {
        key
        startField
        endField
      }
    }
  }
}
    `;
export type DeleteMeetingMutationFn = Apollo.MutationFunction<DeleteMeetingMutation, DeleteMeetingMutationVariables>;

/**
 * __useDeleteMeetingMutation__
 *
 * To run a mutation, you first call `useDeleteMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeetingMutation, { data, loading, error }] = useDeleteMeetingMutation({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useDeleteMeetingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMeetingMutation, DeleteMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMeetingMutation, DeleteMeetingMutationVariables>(DeleteMeetingDocument, options);
      }
export type DeleteMeetingMutationHookResult = ReturnType<typeof useDeleteMeetingMutation>;
export type DeleteMeetingMutationResult = Apollo.MutationResult<DeleteMeetingMutation>;
export type DeleteMeetingMutationOptions = Apollo.BaseMutationOptions<DeleteMeetingMutation, DeleteMeetingMutationVariables>;
export const MeetingsDocument = gql`
    query Meetings($meetingId: Int!) {
  meetings(id: $meetingId) {
    items {
      id
      startTime
      length
      summary
      pinCode
      description
      roomId
      allowUnmute
    }
  }
}
    `;

/**
 * __useMeetingsQuery__
 *
 * To run a query within a React component, call `useMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingsQuery({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useMeetingsQuery(baseOptions: Apollo.QueryHookOptions<MeetingsQuery, MeetingsQueryVariables> & ({ variables: MeetingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingsQuery, MeetingsQueryVariables>(MeetingsDocument, options);
      }
export function useMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingsQuery, MeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingsQuery, MeetingsQueryVariables>(MeetingsDocument, options);
        }
// @ts-ignore
export function useMeetingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeetingsQuery, MeetingsQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingsQuery, MeetingsQueryVariables>;
export function useMeetingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingsQuery, MeetingsQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingsQuery | undefined, MeetingsQueryVariables>;
export function useMeetingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingsQuery, MeetingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingsQuery, MeetingsQueryVariables>(MeetingsDocument, options);
        }
export type MeetingsQueryHookResult = ReturnType<typeof useMeetingsQuery>;
export type MeetingsLazyQueryHookResult = ReturnType<typeof useMeetingsLazyQuery>;
export type MeetingsSuspenseQueryHookResult = ReturnType<typeof useMeetingsSuspenseQuery>;
export type MeetingsQueryResult = Apollo.QueryResult<MeetingsQuery, MeetingsQueryVariables>;
export const MeetingViewDocument = gql`
    query MeetingView($meetingId: Int!) {
  meetings(id: $meetingId) {
    items {
      id
      startTime
      length
      summary
      pinCode
      description
      roomId
      allowUnmute
    }
  }
  invitations(meetingId: $meetingId) {
    items {
      id
      pinCodeRequired
      callout
      muted
      email
      phoneNumber
      name
      uuid
      type
      isAutoGenerated
      meetingId
      joinUrl
    }
  }
}
    `;

/**
 * __useMeetingViewQuery__
 *
 * To run a query within a React component, call `useMeetingViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingViewQuery({
 *   variables: {
 *      meetingId: // value for 'meetingId'
 *   },
 * });
 */
export function useMeetingViewQuery(baseOptions: Apollo.QueryHookOptions<MeetingViewQuery, MeetingViewQueryVariables> & ({ variables: MeetingViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingViewQuery, MeetingViewQueryVariables>(MeetingViewDocument, options);
      }
export function useMeetingViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingViewQuery, MeetingViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingViewQuery, MeetingViewQueryVariables>(MeetingViewDocument, options);
        }
// @ts-ignore
export function useMeetingViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeetingViewQuery, MeetingViewQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingViewQuery, MeetingViewQueryVariables>;
export function useMeetingViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingViewQuery, MeetingViewQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingViewQuery | undefined, MeetingViewQueryVariables>;
export function useMeetingViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingViewQuery, MeetingViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingViewQuery, MeetingViewQueryVariables>(MeetingViewDocument, options);
        }
export type MeetingViewQueryHookResult = ReturnType<typeof useMeetingViewQuery>;
export type MeetingViewLazyQueryHookResult = ReturnType<typeof useMeetingViewLazyQuery>;
export type MeetingViewSuspenseQueryHookResult = ReturnType<typeof useMeetingViewSuspenseQuery>;
export type MeetingViewQueryResult = Apollo.QueryResult<MeetingViewQuery, MeetingViewQueryVariables>;